/**
 * Onglets du Cockpit — source unique (ids canoniques + libellés).
 * Cockpit modulable : `tenant.cockpit_tabs` = liste d'ids visibles (null = tous).
 * Les ids DOIVENT rester alignés avec le backend (core/entitlements.COCKPIT_TABS).
 */
// `scopes` = périmètre exigé EN LECTURE pour voir l'onglet. Le Cockpit est une
// page toujours accessible, mais son CONTENU ne l'est pas : ses quatre premiers
// onglets sont des agrégats financiers (structure de financement, ratios
// d'endettement, contrôles art. 725 CO), le dernier relève de la gouvernance.
/* « Journal & décisions » OUVRE le groupe Cockpit (2026-09-16) : ce qui a
   été décidé se lit avant les chiffres qui l'ont motivé. FOCUS+ en est parti
   le 2026-09-18, pour Finance après les indicateurs : c'est un atelier
   d'analyse, pas une vue de direction. Un id retiré d'ici disparaît de lui-même
   des `cockpit_tabs` d'un client, la route les filtrant sur cette liste. L'ordre de ce tableau
   commande le panneau du menu ; la vue ouverte par défaut reste la
   rentabilité (`rent`), le journal ne s'ouvrant que si on le demande. */
/* JOURNAL et DÉCISIONS sont DEUX sections (2026-09-18), au-dessus du groupe
   Cockpit : on y observe d'un côté, on y suit ce qui est décidé de l'autre, et
   une bascule dans la page disait ce qu'un menu dit mieux. Elles gardent le
   même document et le même écran, seule la vue ouverte change. */
export const COCKPIT_TABS = [
  { id: 'journal', labelKey: 'cockpit:tabs.journal', scopes: ['governance'], aside: true },
  { id: 'decisions', labelKey: 'cockpit:tabs.decisions', scopes: ['governance'], aside: true },
  { id: 'rent', labelKey: 'cockpit:tabs.rent', scopes: ['financials'] },
  { id: 'liq', labelKey: 'cockpit:tabs.liq', scopes: ['financials'] },
  { id: 'fin', labelKey: 'cockpit:tabs.fin', scopes: ['financials'] },
];

export const COCKPIT_TAB_IDS = COCKPIT_TABS.map((t) => t.id);

// Onglets visibles = activés pour le client ∩ lisibles par la personne.
// `enabledIds` null/undefined → tous les onglets côté client (pack complet).
// `scopes` omis → aucun filtre par périmètre (rendu hors session, ex. impression).
/* LES VUES DU COCKPIT DEMANDENT LE MODULE FINANCE (décision Olivier,
   2026-10-03) : elles ne lisent que des chiffres financiers. Le périmètre
   `financials` ne suffit pas, Ventes & Ops l'ouvre aussi ; un client sans
   Finance ne garde que le Journal et les Décisions. `modules` = le pack du
   client (`enabled_modules`) ; absent, rien ne se filtre sur le module. */
export function visibleCockpitTabs(enabledIds, scopes, modules = null) {
  const hasFinance = !Array.isArray(modules) || modules.includes('financials');
  const enabled = (Array.isArray(enabledIds)
    ? COCKPIT_TABS.filter((t) => enabledIds.includes(t.id))
    : COCKPIT_TABS).filter((t) => hasFinance || !(t.scopes || []).includes('financials'));
  if (!scopes) return enabled;
  const canRead = (s) => scopes[s] === 'r' || scopes[s] === 'rw';
  return enabled.filter((t) => !t.scopes || t.scopes.some(canRead));
}
